import { render } from "./Champ_Licence.vue?vue&type=template&id=30efccae"
import script from "./Champ_Licence.vue?vue&type=script&lang=js"
export * from "./Champ_Licence.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__